import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Order as Entity } from './order.model';
import * as EntityActions from './order.actions';
import { OrderService } from './order.service';
import { IResultWithPageInfo } from '../app-store.interfaces';

@Injectable()
export class OrderEffects {
    loadPage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EntityActions.loadPage),
            switchMap(({ page, correlationId }) =>
                this.orderService.loadPage(page.pageNumber, page.pageSize).pipe(
                    map((resultWithPageInfo: IResultWithPageInfo<Entity>) =>
                        EntityActions.loadPageSuccess({ resultWithPageInfo, correlationId })
                    ),
                    catchError((error) =>
                        of(EntityActions.loadPageFailure({ error, correlationId }))
                    )
                )
            )
        )
    );

    loadSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EntityActions.loadSingle),
            switchMap(({ entityId, correlationId }) =>
                this.orderService.loadSingle(entityId).pipe(
                    map((entity: Entity) =>
                        EntityActions.loadSingleSuccess({ entity, correlationId })
                    ),
                    catchError((error) =>
                        of(EntityActions.loadSingleFailure({ error, correlationId }))
                    )
                )
            )
        )
    );

    constructor(private actions$: Actions, private orderService: OrderService) {}
}
